export default __webpack_public_path__ + "static/media/map-marker-red.2ede3da6.svg";